import { registerLocaleData } from '@angular/common';
import localeCs from '@angular/common/locales/cs';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}
registerLocaleData(localeCs, 'cs');

bootstrapApplication(AppComponent, appConfig)
    // eslint-disable-next-line no-console
    .catch((err) => console.log(err));
